import React, { useState, useEffect, useContext } from "react";
import NavigationBar from "../components/Navigation";
import Footer from "../components/Footer";
import {
  collection,
  getDocs,
  getDoc,
  query,
  orderBy,
  doc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
  where,
  limit,
  startAfter,
} from "firebase/firestore";
import { db } from "../config/firebasedeconfig";
import "../styles/components/Forum.scss";
import { OnlineUsersContext } from "../OnlineUsersContext";
import { UserContext } from "../UserContext";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultAvatarUrl, defaultUsername, defaultEmail } from '../constants';
import TsparticlesForForum from '../components/tsparticles_For_Forum';
import { getUserActivityScore } from '../components/levelUtils';
import UserXpAvatar from "../components/UserXpAvatar";
import { useRive } from '@rive-app/react-canvas';
import rain_world_iterator_halo from "../components/rain_world_iterator_halo.riv";
import { RefreshContext } from "../components/RefreshContext";
import { RefreshProvider } from "../components/RefreshContext";
import { forumCategories } from "../components/categoriesForum";
import Banner3D from '../components/Banner3D';
import BackToTopButton from '../components/BackToTopButton';
import { useLanguage } from '../contexts/LanguageContext';
import { deleteForumPost } from "../services/forumActivityService";


const Forum = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const { onlineUsers } = useContext(OnlineUsersContext);
  const {
    username,
    isLoggedIn,
    setRedirectTo,
    userId,
    messageCount,
    updateMessageCount,
    fetchUserMessageCount
  } = useContext(UserContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [showRules, setShowRules] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [posts, setPosts] = useState([]);
  const [onlineUsersCheck, setOnlineUsersCheck] = useState([]);
  const uid = localStorage.getItem("uid");
  const [editingPost, setEditingPost] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editContent, setEditContent] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const { avatar, setAvatar } = useContext(UserContext);
  const [showMoreCategories, setShowMoreCategories] = useState(false);
  const categories = forumCategories || []; // Défini avant toute utilisation
  const popularCategories = categories.slice(0, 5); // 5 catégories populaires
  const otherCategories = categories.slice(5); // Les autres catégories
  const [showSecondaryDropdown, setShowSecondaryDropdown] = useState(false);
  const darkwaterImageUrl = process.env.PUBLIC_URL + "/images/darkwater.jpg";
  const frenzyMimiWallImageUrl = process.env.PUBLIC_URL + "/images/frenzyMimiWall01.png";

  const getCloudinaryAvatar = (avatarUrl) => {
    if (!avatarUrl || avatarUrl === defaultAvatarUrl) {
      return defaultAvatarUrl; // Ne pas optimiser l'avatar par défaut
    }
    return avatarUrl;
  };

  // Active le mode test pourle système de titre en mettant `true` à cette variable
  // const debugTestMode = true;
  const debugTestMode = false;

  /* Aspirant Figurant(0 à 9)
  Cadreur Novice(10 à 49)
  Apprenti Monteur(50 à 99)
  Assistant Réalisateur(100 à 199)
  Scénariste Prometteur(200 à 499)
  Chef Opérateur Illumineur(500 à 999)
  Réalisateur Émérite(1000 à 1999)
  Maître de la Mise en Scène(2000 à 3999)
  Légende du 7e Art(4000 à 6999)
  Divinité de la Pellicule(7000 et +)
   */

  // const testMessageCount = 5;    // "Aspirant Figurant"
  // const testMessageCount = 13;    // "Cadreur Novice" *
  // const testMessageCount = 50;    // "Apprenti Monteur"
  // const testMessageCount = 100;   // "Assistant Réalisateur"*   
  // const testMessageCount = 200;   // "Scénariste Prometteur"*
  // const testMessageCount = 500;   // "Chef Opérateur Illumineur"*
  // const testMessageCount = 1000;  // "Réalisateur Émérite"*  
  // const testMessageCount = 2000;  // "Maître de la Mise en Scène"
  // const testMessageCount = 4000;  // "Légende du 7e Art"
  const testMessageCount = 7500;  // "Divinité de la Pellicule"
  const displayMessageCount = debugTestMode ? testMessageCount : messageCount;

  // Chargement du composant Rive
  const { RiveComponent } = useRive({
    src: require("../components/rain_world_iterator_halo.riv"),
    autoplay: true,
  });


  // Gestion de clic pour afficher le deuxième menu des catégories
  const handleMoreCategoriesClick = () => {
    const newState = !showSecondaryDropdown;
    console.log("Basculement du menu secondaire :", newState);
    setShowSecondaryDropdown(newState);
  };

  // Mettre à jour la liste des catégories secondaires
  const secondaryCategories = [
    { id: "action", name: "Action" },
    { id: "aventure", name: "Aventure" },
    { id: "animation", name: "Animation" },
    { id: "biographie", name: "Biographie" },
    { id: "comedie", name: "Comédie" },
    { id: "crime", name: "Crime" },
    { id: "documentaire", name: "Documentaire" },
    { id: "drame", name: "Drame" },
    { id: "fantastique", name: "Fantastique" },
    { id: "guerre", name: "Guerre" },
    { id: "histoire", name: "Histoire" },
    { id: "horreur", name: "Horreur" },
    { id: "musique", name: "Musique" },
    { id: "mystere", name: "Mystère" },
    { id: "romance", name: "Romance" },
    { id: "science-fiction", name: "Science-Fiction" },
    { id: "telefilm", name: "Téléfilm" },
    { id: "thriller", name: "Thriller" },
    { id: "western", name: "Western" }
  ];


  // Liste des posts
  const [lastVisible, setLastVisible] = useState(null);

  const enrichPostWithAuthor = async (docSnap) => {
    const post = {
      id: docSnap.id,
      ...docSnap.data(),
    };

    if (!post.content) return null;

    const cleanedContent = post.content.replace(/(<([^>]+)>)/gi, "");

    if (!post.authorId) {
      return {
        ...post,
        content: cleanedContent,
        avatar: defaultAvatarUrl,
        authorName: post.author || t("forum.authorUnknown"),
        messageCount: 0,
        activityScore: 0,
      };
    }

    const authorMessageCount = await fetchUserMessageCount(post.authorId);

    try {
      const userDocRef = doc(db, "users", post.authorId);
      const userDoc = await getDoc(userDocRef);

      if (!userDoc.exists()) {
        return {
          ...post,
          content: cleanedContent,
          avatar: defaultAvatarUrl,
          authorName: post.author || t("forum.authorUnknown"),
          messageCount: authorMessageCount,
          activityScore: getUserActivityScore({}, authorMessageCount),
        };
      }

      const authorData = userDoc.data() || {};

      return {
        ...post,
        content: cleanedContent,
        avatar: authorData.avatar || defaultAvatarUrl,
        authorName: authorData.username || post.author || t("forum.userUnknown"),
        messageCount: authorMessageCount,
        activityScore: getUserActivityScore(authorData, authorMessageCount),
      };
    } catch (error) {
      console.error("Erreur lors de l'enrichissement du post :", error);

      return {
        ...post,
        content: cleanedContent,
        avatar: defaultAvatarUrl,
        authorName: post.author || t("forum.authorUnknown"),
        messageCount: authorMessageCount,
        activityScore: getUserActivityScore({}, authorMessageCount),
      };
    }
  };

  // Récupérer les posts depuis Firestore
  const fetchPosts = async () => {
    try {
      if (!db) {
        console.error("Erreur : pas de base de données");
        return;
      }

      const postsQuery = query(
        collection(db, "posts"),
        orderBy("timestamp", "desc"),
        // Détermine le nombre limite de cards du carrousssel
        limit(10)
      );

      const querySnapshot = await getDocs(postsQuery);
      const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

      if (querySnapshot.empty) {
        console.log("Aucun post.");
        setPosts([]);
        setLastVisible(null);
        return;
      }

      const postsData = await Promise.all(
        querySnapshot.docs.map(enrichPostWithAuthor)
      );

      setPosts(postsData.filter(Boolean));
      setLastVisible(lastDoc || null);
    } catch (error) {
      console.error("Erreur lors de la récupération des posts :", error);
    }
  };


  // Récupérer l'avatar du créateur du post
  const fetchAvatar = async (userId) => {
    try {
      const userRef = doc(db, "users", userId);
      const docSnap = await getDoc(userRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setAvatar(data.avatar);
      }
    } catch (error) {
      console.error("Erreur lors de la sélection de l'utilisateur :", error);
    }
  };



  // Charger plus de posts
  const loadMorePosts = async () => {
    try {
      if (!lastVisible) return;

      const nextQuery = query(
        collection(db, "posts"),
        orderBy("timestamp", "desc"),
        startAfter(lastVisible),
        limit(10)
      );

      const querySnapshot = await getDocs(nextQuery);
      const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

      if (querySnapshot.empty) {
        setLastVisible(null);
        return;
      }

      const postsData = await Promise.all(
        querySnapshot.docs.map(enrichPostWithAuthor)
      );

      setPosts((prevPosts) => [
        ...prevPosts,
        ...postsData.filter(Boolean),
      ]);

      setLastVisible(lastDoc || null);
    } catch (error) {
      console.error("Erreur lors du chargement des posts :", error);
    }
  };

  const sortPosts = async (sortBy = "timestamp") => {
    const postsQuery = query(
      collection(db, "posts"),
      orderBy(sortBy, "desc"),
      limit(10)
    );
    const querySnapshot = await getDocs(postsQuery);
    const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return posts; // Return the posts array
  };


  useEffect(() => {
    fetchPosts();

    if (userId) {
      fetchAvatar(userId);
    }
  }, []);

  // Nombre de cartes Banner3D selon la largeur de l'écran
  const mobileLimit = 6;
  const desktopLimit = 10;

  const [isMobileBanner, setIsMobileBanner] = useState(() =>
    window.matchMedia("(max-width: 767px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    const handleBannerBreakpoint = (event) => {
      setIsMobileBanner(event.matches);
    };

    setIsMobileBanner(mediaQuery.matches);

    mediaQuery.addEventListener("change", handleBannerBreakpoint);

    return () => {
      mediaQuery.removeEventListener("change", handleBannerBreakpoint);
    };
  }, []);

  // Filtrer les posts en fonction de la recherche et de la catégorie
  const filteredPosts = posts.filter((post) => {
    const matchesSearch = post.title?.toLowerCase()?.includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "all" || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });


  // Gestion du clic sur une catégorie
  const handleCategorySelect = (id) => {
    console.log("Catégorie sélectionnée :", id); // Vérifie l'exécution
    setSelectedCategory(id);
    setTimeout(() => {
      setDropdownOpen(false);
      setShowSecondaryDropdown(false);
    }, 100); // Laisse le temps au clic de s'exécuter
  };


  // Log le contenu du tableau categories
  console.log("Liste des catégories :", categories);

  // Gestion de la creation d'un post
  const handleCreatePost = () => {
    if (!isLoggedIn) {
      setRedirectTo("/Forum?openModal=true");
      navigate("/connexion");
      return;
    }

    navigate("/create-subject");
  };


  // Détecter le paramètre `openModal` dans l'URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("openModal") === "true") {
      setIsModalOpen(true);
    }
  }, [location]);


  // Gestion de la suppression d'un post
  const handleDelete = async (post) => {
    const postId = post?.id;

    if (!postId) return;

    const isDisplayedAsMovieReview =
      post?.source === "movie_rating_review" ||
      post?.type === "movie_rating_discussion";

    const confirmed = window.confirm(
      isDisplayedAsMovieReview
        ? "Supprimer ce sujet d'avis MovieFrenzy ? Le sujet et tous les avis publiés seront retirés, mais les notes seront conservées."
        : "Supprimer ce sujet ?"
    );

    if (!confirmed) return;

    try {
      await deleteForumPost({ postId });

      setPosts((prevPosts) =>
        prevPosts.filter((currentPost) => currentPost.id !== postId)
      );

      console.log(
        `[Forum] Sujet ${postId} et données associées supprimés avec succès.`
      );
    } catch (error) {
      console.error(
        "Erreur lors de la suppression du sujet :",
        error
      );

      alert(
        "Une erreur est survenue lors de la suppression du sujet. Veuillez réessayer."
      );
    }
  };



  const setUserOnline = async (uid) => {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, { isOnline: true });
  };

  const setUserOffline = async (uid) => {
    const userRef = doc(db, "users", uid);
    await updateDoc(userRef, { isOnline: false });
  };

  useEffect(() => {
    if (uid) {
      setUserOnline(uid); // Définit l'utilisateur comme en ligne
    }

    // Nettoyage à la suppression du composant ou au changement de uid
    return () => {
      if (uid) {
        setUserOffline(uid); // Définit l'utilisateur comme hors ligne avant de quitter
      }
    };
  }, [uid]);

  const fetchOnlineUsers = () => {
    const q = query(collection(db, "users"), where("isOnline", "==", true)); // Filtrer les utilisateurs en ligne
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const onlineUsers = snapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      console.log("Utilisateurs en ligne :", onlineUsers);
      setOnlineUsersCheck(onlineUsers); // Met à jour l'état avec les utilisateurs en ligne
    });

    return unsubscribe; // Retourne l'écouteur pour le nettoyage
  };

  useEffect(() => {
    const unsubscribe = fetchOnlineUsers(); // Récupère l'écouteur
    return () => unsubscribe(); // Nettoyage à la suppression du composant
  }, []);

  const limitedUsers = onlineUsers.slice(0, 10); // Affiche les 10 premiers utilisateurs en ligne

  // Pour modifier un post
  const handleEdit = (post) => {
    navigate(`/edit-subject/${post.id}`);
  };



  // Pour annuler la modification
  const handleCancelEdit = () => {
    setEditingPost(null);
    setEditTitle("");
    setEditContent("");
  };

  const handleSaveEdit = async () => {
    if (!editTitle || !editContent) {
      alert("Tous les champs doivent être remplis !");
      return;
    }

    try {
      const postRef = doc(db, "posts", editingPost); // Référence du document en cours d'édition
      await updateDoc(postRef, {
        title: editTitle,
        content: editContent,
        timestamp: serverTimestamp(), // Met à jour le timestamp
      });
      fetchPosts(); // Actualise la liste des posts
      setEditingPost(null); // Ferme le mode édition
    } catch (error) {
      console.error("Erreur lors de la modification :", error);
    }
  };

  // Gestion du clic sur un sujet pour redirection
  const handleSubjectClick = (postId) => {
    navigate(`/subject/${postId}`); // Redirige vers la page du sujet
  };

  // // Gestion du comptage des réponses
  const fetchReplyCount = async (postId) => {
    try {
      // Compter les réponses dans la sous-collection "replies"
      const repliesQuery = query(collection(db, "posts", postId, "replies"));
      const repliesSnapshot = await getDocs(repliesQuery);
      const repliesCount = repliesSnapshot.size;

      // Inclure le post lui-même comme un "message"
      return repliesCount + 1; // Ajoute le sujet principal
    } catch (err) {
      console.error("Erreur lors du comptage des réponses :", err);
      return 1; // Par défaut, inclure au moins le sujet lui même
    }
  };

  // ogique d'affichage pour chercher dans plusieurs tableaux
  const selectedCategoryObj =
    categories.find(cat => cat.id === selectedCategory) ||
    secondaryCategories.find(cat => cat.id === selectedCategory);

  // Fonction pour trier les sujets
  const getTopicActivityTime = (topic) => {
    return topic.lastActivityAt?.seconds || topic.timestamp?.seconds || 0;
  };

  const getLikeCount = (likes) => {
    return Array.isArray(likes) ? likes.length : Number(likes || 0);
  };

  const sortTopics = (topics) => {
    return [...topics].sort((a, b) => {
      const bActivityTime = getTopicActivityTime(b);
      const aActivityTime = getTopicActivityTime(a);

      if (bActivityTime !== aActivityTime) {
        return bActivityTime - aActivityTime;
      }

      const bReplies = Number(b.replies || 0);
      const aReplies = Number(a.replies || 0);

      if (bReplies !== aReplies) {
        return bReplies - aReplies;
      }

      return getLikeCount(b.likes) - getLikeCount(a.likes);
    });
  };

  const visiblePosts = sortTopics(filteredPosts);

  const popularTopics = sortTopics(posts).slice(0, desktopLimit);

  const bannerTopics = popularTopics.slice(
    0,
    isMobileBanner ? mobileLimit : desktopLimit
  );


  return (
    <>
      <div
        className="forum-page"
        style={{
          backgroundImage: `url(${darkwaterImageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundBlendMode: "overlay",
          backgroundColor: "#200211",
          opacity: "0.9",
          overflowX: "hidden",
          overflowY: "auto",
          minHeight: "100vh",
        }}
      >
        <NavigationBar />
        <div className="forum-container">
          <div
            className="forum-banner3d-wrapper"
            style={{
              width: "100%",
              height: "100%",
              zIndex: "100001",
              marginTop: "1rem"
            }}
          >
            <h2 className="forum-hot-topics-mobile">
              {t('banner3d.hotTopics')}
            </h2>

            <Banner3D topics={bannerTopics} />
          </div>

          <div className="forum-controls" style={{ marginTop: '3rem' }}>
            <input
              type="text"
              placeholder={t('forum.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="custom-dropdown">
              <div className="selected-option" onClick={() => setDropdownOpen(!dropdownOpen)}>
                {selectedCategoryObj ? t(`forum.forumCategories.${selectedCategoryObj.id}`) : t('forum.categoryPlaceholder')}
                <span className={`chevron ${dropdownOpen ? "open" : ""}`}>
                  {dropdownOpen ? "▲" : "▼"}
                </span>
              </div>
              {dropdownOpen && (
                <div className="dropdown-compartments">
                  <ul className="popular-categories">
                    {popularCategories.map((cat) => (
                      <li
                        key={cat.id}
                        onClick={(e) => {
                          e.stopPropagation(); // Empêche l'interception
                          console.log("Catégorie secondaire cliquée :", cat.id); // Debug
                          console.log("dropdownOpen :", dropdownOpen, "showSecondaryDropdown :", showSecondaryDropdown);
                          console.log("[POPULAIRE] Catégorie cliquée :", cat.id);
                          handleCategorySelect(cat.id);
                        }}
                      >
                        {t(`forum.forumCategories.${cat.id}`)}
                      </li>
                    ))}
                    <li
                      className="more-categories"
                      onClick={(e) => {
                        e.stopPropagation(); // Empêche l'interception
                        handleMoreCategoriesClick();
                      }}
                    >
                      {t('forum.moreCategories')}
                    </li>
                    {showSecondaryDropdown && (
                      <ul className={`secondary-categories ${dropdownOpen ? "active" : ""}`}>
                        {/* <ul className="secondary-categories">   */}
                        {secondaryCategories.map((cat) => (
                          <li
                            key={cat.id}
                            tabIndex={0}
                            role="menuitem"
                            onClick={(e) => {
                              e.stopPropagation(); // Empêche l'interception
                              console.log("Catégorie secondaire cliquée :", cat.id); // Debug
                              console.log("[SECONDAIRE] Catégorie cliquée :", cat.id);
                              handleCategorySelect(cat.id);
                            }}
                          >
                            {t(`forum.forumCategories.${cat.id}`)}
                          </li>
                        ))}
                      </ul>
                    )}
                  </ul>
                  {showMoreCategories && (
                    <ul className="other-categories">
                      {otherCategories.map((cat) => (
                        <li key={cat.id} onClick={() => handleCategorySelect(cat.id)}>
                          {t(`forum.forumCategories.${cat.id}`)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
            <button
              className="buttonForum01"
              onClick={() => setShowRules(!showRules)}
            >
              {t('forum.showRules')}
            </button>
            <button className="buttonForum01" onClick={handleCreatePost}>
              {t('forum.createTopic')}
            </button>
          </div>
          {showRules && (
            <div className="forum-rules">
              <h2>{t('forum.rulesTitle')}</h2>
              <ul>
                {t('forum.rules', { returnObjects: true }).map((rule, index) => (
                  <li key={index}>{rule}</li>
                ))}
              </ul>
            </div>
          )}
          {visiblePosts && visiblePosts.length > 0 ? (
            visiblePosts.map((post) => {
              const postActivityScore = debugTestMode
                ? testMessageCount
                : (post.activityScore ?? post.messageCount ?? 0);

              console.log("Niveau envoyé à UserXpAvatar :", postActivityScore);

              return (
                <div
                  key={post.id}
                  className="forum-post"
                  style={{
                    marginBottom: "1.25rem",
                    padding: "1.5rem",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: "0.5rem",
                    boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.5)",
                    cursor: "pointer", // Ajout pour indiquer que c'est cliquable
                    transition: "background-color 0.3s",
                    border: "2px solid #00FFFF",
                  }}
                  onClick={() => navigate(`/subject/${post.id}`)}
                >
                  <h3 className="Title_topic" style={{ color: "#00FFFF" }}>
                    {post.title}
                  </h3>
                  <p dangerouslySetInnerHTML={{ __html: post.content }}></p>
                  <div
                    className="post-details"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "0.8rem",
                      fontSize: "0.9rem",
                      borderColor: "#FF33CC",
                      borderTop: "2px solid #FF33CC",
                      padding: "1.5rem",
                      borderStyle: "dotted",
                      filter: "brightness(0.9) drop-shadow(0 0 0.5rem #FF33CC)",
                    }}
                  >
                    <div
                      className="avatar-containerForumHome"
                      style={{
                        color: "#00FFFF",
                        fontSize: "0.8rem",
                        backgroundColor: "#200211",
                        padding: "0.5rem",
                        borderRadius: "0.25rem",
                      }}
                    >
                      {t('forum.by')}{" "}
                      <span style={{ fontWeight: "bold", color: "white" }}>
                        {post.authorName || post.author || t('forum.authorUnknown')}
                      </span>
                      <div
                        className="avatar-containerForumHome"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "0.5rem",
                          gap: "0.5rem",
                          flexDirection: "row",
                        }}
                      >
                        <UserXpAvatar
                          avatarUrl={post.avatar || defaultAvatarUrl}
                          activityScore={postActivityScore}
                          fallbackActivityScore={post.messageCount}
                          userId={post.authorId}
                          titleLabel={t("forum.levelTitle")}
                          activityLabel={t("forum.activityScore")}
                          className="user-xp-avatar--forum-home"
                        />
                      </div>
                    </div>
                    <span style={{ color: "#00FFFF" }}>
                      {t('forum.category')}{" "}
                      <span style={{ fontWeight: "bold", color: "white" }}>
                        {t(`forum.forumCategories.${post.category}`)}
                      </span>
                    </span>
                    <span
                      style={{
                        color: "#00FFFF",
                        fontSize: "0.8rem",
                        cursor: "pointer",
                        padding: "0.2rem",
                        borderRadius: "0.25rem",
                      }}
                    >
                      {post.timestamp?.seconds
                        ? new Date(post.timestamp.seconds * 1000).toLocaleString()
                        : t('forum.dateUnknown')}
                    </span>
                  </div>
                  {post.authorId === userId && (
                    <div className="button-container">
                      <button
                        onClick={(e) => {
                          e.stopPropagation(); // Arrête la propagation vers le parent
                          handleEdit(post);
                        }}
                        className="editButton"
                      >
                        {t('forum.edit')}
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete(post);
                        }}
                        className="deleteButton"
                      >
                        {t('forum.delete')}
                      </button>
                    </div>
                  )}
                  {editingPost === post.id && (
                    <div>
                      <h3>{t('forum.editTopic.pageTitle')}</h3>
                      <label>
                        {t('forum.editTopic.titleLabel')}
                        <input
                          type="text"
                          value={editTitle}
                          onChange={(e) => setEditTitle(e.target.value)}
                        />
                      </label>
                      <label>
                        {t('forum.editTopic.contentLabel')}
                        <textarea
                          value={editContent}
                          onChange={(e) => setEditContent(e.target.value)}
                        />
                      </label>
                      <button onClick={handleSaveEdit} className="editButton">
                        {t('forum.editTopic.save')}
                      </button>
                      <button
                        onClick={() => handleCancelEdit()}
                        className="cancelButton"
                      >
                        {t('forum.editTopic.cancel')}
                      </button>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <p>{t('forum.noTopics')}</p>
          )}
          <button onClick={loadMorePosts} disabled={!lastVisible} className="buttonForumChargerMore" style={{ filter: "drop-shadow(0px 0px 10px rgba(255, 51, 204))" }}>
            <span className="chargerSpanButtonForum" data-loading-text={t('forum.loadingText')}>
              {t('forum.loadMore')}
            </span>
          </button>
          <div className="forum-online-users"
            style={{
              color: "#00FFFF",
              fontSize: "0.8rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderColor: "#FF33CC",
              borderTop: "2px solid #FF33CC",
              padding: "1.5rem",
              borderStyle: "dotted",
              filter: "brightness(0.9) drop-shadow(0 0 0.5rem #FF33CC)",
              backgroundImage: `url(${frenzyMimiWallImageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundAttachment: "fixed",
              backgroundBlendMode: "overlay",
              backgroundColor: "rgba(32, 0, 17, 0.75)",
            }}
          >
            <TsparticlesForForum />
            <h2>{t('forum.onlineUsers')}</h2>
            {onlineUsersCheck.length === 0 ? (
              <p>{t('forum.noOnlineUsers')}</p>
            ) : (
              <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", margin: "0.5rem auto 0.5rem auto" }}>
                {onlineUsersCheck.map((user) => (
                  <li key={user.uid} style={{ marginBottom: "0.5rem", color: "#FFFFFF", fontSize: "0.8rem", marginRight: "calc(50% - 48.25vw)", marginLeft: "calc(50% - 50vw)", textShadow: "0 0 0.5rem #000" }}>{user.username || t('forum.anonymousUser')}</li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>
      <div>
        <BackToTopButton />
      </div>
      <div className="actor-details-footer"
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      >
        <Footer />
      </div>
    </>
  );
};

export default Forum;





// import React, { useState, useEffect, useContext } from "react";
// import NavigationBar from "../components/Navigation";
// import Footer from "../components/Footer";
// import {
//   collection,
//   getDocs,
//   getDoc,
//   query,
//   orderBy,
//   doc,
//   deleteDoc,
//   updateDoc,
//   serverTimestamp,
//   onSnapshot,
//   where,
//   limit,
//   startAfter,
//   deleteField,
//   increment,
//   writeBatch,
// } from "firebase/firestore";
// import { db } from "../config/firebasedeconfig";
// import "../styles/components/Forum.scss";
// import { OnlineUsersContext } from "../OnlineUsersContext";
// import { UserContext } from "../UserContext";
// import { useNavigate, useLocation } from "react-router-dom";
// import { defaultAvatarUrl, defaultUsername, defaultEmail } from '../constants';
// import TsparticlesForForum from '../components/tsparticles_For_Forum';
// import { getUserActivityScore } from '../components/levelUtils';
// import UserXpAvatar from "../components/UserXpAvatar";
// import { useRive } from '@rive-app/react-canvas';
// import rain_world_iterator_halo from "../components/rain_world_iterator_halo.riv";
// import { RefreshContext } from "../components/RefreshContext";
// import { RefreshProvider } from "../components/RefreshContext";
// import { forumCategories } from "../components/categoriesForum";
// import Banner3D from '../components/Banner3D';
// import BackToTopButton from '../components/BackToTopButton';
// import { useLanguage } from '../contexts/LanguageContext';


// const Forum = () => {
//   const { t } = useLanguage();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { onlineUsers } = useContext(OnlineUsersContext);
//   const {
//     username,
//     isLoggedIn,
//     setRedirectTo,
//     userId,
//     messageCount,
//     updateMessageCount,
//     fetchUserMessageCount
//   } = useContext(UserContext);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [showRules, setShowRules] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [posts, setPosts] = useState([]);
//   const [onlineUsersCheck, setOnlineUsersCheck] = useState([]);
//   const uid = localStorage.getItem("uid");
//   const [editingPost, setEditingPost] = useState(null);
//   const [editTitle, setEditTitle] = useState("");
//   const [editContent, setEditContent] = useState("");
//   const [isHovered, setIsHovered] = useState(false);
//   const { avatar, setAvatar } = useContext(UserContext);
//   const [showMoreCategories, setShowMoreCategories] = useState(false);
//   const categories = forumCategories || []; // Défini avant toute utilisation
//   const popularCategories = categories.slice(0, 5); // 5 catégories populaires
//   const otherCategories = categories.slice(5); // Les autres catégories
//   const [showSecondaryDropdown, setShowSecondaryDropdown] = useState(false);
//   const darkwaterImageUrl = process.env.PUBLIC_URL + "/images/darkwater.jpg";
//   const frenzyMimiWallImageUrl = process.env.PUBLIC_URL + "/images/frenzyMimiWall01.png";

//   const getCloudinaryAvatar = (avatarUrl) => {
//     if (!avatarUrl || avatarUrl === defaultAvatarUrl) {
//       return defaultAvatarUrl; // Ne pas optimiser l'avatar par défaut
//     }
//     return avatarUrl;
//   };

//   // Active le mode test pourle système de titre en mettant `true` à cette variable
//   // const debugTestMode = true;
//   const debugTestMode = false;

//   /* Aspirant Figurant(0 à 9)
//   Cadreur Novice(10 à 49)
//   Apprenti Monteur(50 à 99)
//   Assistant Réalisateur(100 à 199)
//   Scénariste Prometteur(200 à 499)
//   Chef Opérateur Illumineur(500 à 999)
//   Réalisateur Émérite(1000 à 1999)
//   Maître de la Mise en Scène(2000 à 3999)
//   Légende du 7e Art(4000 à 6999)
//   Divinité de la Pellicule(7000 et +)
//    */

//   // const testMessageCount = 5;    // "Aspirant Figurant"
//   // const testMessageCount = 13;    // "Cadreur Novice" *
//   // const testMessageCount = 50;    // "Apprenti Monteur"
//   // const testMessageCount = 100;   // "Assistant Réalisateur"*   
//   // const testMessageCount = 200;   // "Scénariste Prometteur"*
//   // const testMessageCount = 500;   // "Chef Opérateur Illumineur"*
//   // const testMessageCount = 1000;  // "Réalisateur Émérite"*  
//   // const testMessageCount = 2000;  // "Maître de la Mise en Scène"
//   // const testMessageCount = 4000;  // "Légende du 7e Art"
//   const testMessageCount = 7500;  // "Divinité de la Pellicule"
//   const displayMessageCount = debugTestMode ? testMessageCount : messageCount;

//   // Chargement du composant Rive
//   const { RiveComponent } = useRive({
//     src: require("../components/rain_world_iterator_halo.riv"),
//     autoplay: true,
//   });


//   // Gestion de clic pour afficher le deuxième menu des catégories
//   const handleMoreCategoriesClick = () => {
//     const newState = !showSecondaryDropdown;
//     console.log("Basculement du menu secondaire :", newState);
//     setShowSecondaryDropdown(newState);
//   };

//   // Mettre à jour la liste des catégories secondaires
//   const secondaryCategories = [
//     { id: "action", name: "Action" },
//     { id: "aventure", name: "Aventure" },
//     { id: "animation", name: "Animation" },
//     { id: "biographie", name: "Biographie" },
//     { id: "comedie", name: "Comédie" },
//     { id: "crime", name: "Crime" },
//     { id: "documentaire", name: "Documentaire" },
//     { id: "drame", name: "Drame" },
//     { id: "fantastique", name: "Fantastique" },
//     { id: "guerre", name: "Guerre" },
//     { id: "histoire", name: "Histoire" },
//     { id: "horreur", name: "Horreur" },
//     { id: "musique", name: "Musique" },
//     { id: "mystere", name: "Mystère" },
//     { id: "romance", name: "Romance" },
//     { id: "science-fiction", name: "Science-Fiction" },
//     { id: "telefilm", name: "Téléfilm" },
//     { id: "thriller", name: "Thriller" },
//     { id: "western", name: "Western" }
//   ];


//   // Liste des posts
//   const [lastVisible, setLastVisible] = useState(null);

//   const enrichPostWithAuthor = async (docSnap) => {
//     const post = {
//       id: docSnap.id,
//       ...docSnap.data(),
//     };

//     if (!post.content) return null;

//     const cleanedContent = post.content.replace(/(<([^>]+)>)/gi, "");

//     if (!post.authorId) {
//       return {
//         ...post,
//         content: cleanedContent,
//         avatar: defaultAvatarUrl,
//         authorName: post.author || t("forum.authorUnknown"),
//         messageCount: 0,
//         activityScore: 0,
//       };
//     }

//     const authorMessageCount = await fetchUserMessageCount(post.authorId);

//     try {
//       const userDocRef = doc(db, "users", post.authorId);
//       const userDoc = await getDoc(userDocRef);

//       if (!userDoc.exists()) {
//         return {
//           ...post,
//           content: cleanedContent,
//           avatar: defaultAvatarUrl,
//           authorName: post.author || t("forum.authorUnknown"),
//           messageCount: authorMessageCount,
//           activityScore: getUserActivityScore({}, authorMessageCount),
//         };
//       }

//       const authorData = userDoc.data() || {};

//       return {
//         ...post,
//         content: cleanedContent,
//         avatar: authorData.avatar || defaultAvatarUrl,
//         authorName: authorData.username || post.author || t("forum.userUnknown"),
//         messageCount: authorMessageCount,
//         activityScore: getUserActivityScore(authorData, authorMessageCount),
//       };
//     } catch (error) {
//       console.error("Erreur lors de l'enrichissement du post :", error);

//       return {
//         ...post,
//         content: cleanedContent,
//         avatar: defaultAvatarUrl,
//         authorName: post.author || t("forum.authorUnknown"),
//         messageCount: authorMessageCount,
//         activityScore: getUserActivityScore({}, authorMessageCount),
//       };
//     }
//   };

//   // Récupérer les posts depuis Firestore
//   const fetchPosts = async () => {
//     try {
//       if (!db) {
//         console.error("Erreur : pas de base de données");
//         return;
//       }

//       const postsQuery = query(
//         collection(db, "posts"),
//         orderBy("timestamp", "desc"),
//         // Détermine le nombre limite de cards du carrousssel
//         limit(10)
//       );

//       const querySnapshot = await getDocs(postsQuery);
//       const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

//       if (querySnapshot.empty) {
//         console.log("Aucun post.");
//         setPosts([]);
//         setLastVisible(null);
//         return;
//       }

//       const postsData = await Promise.all(
//         querySnapshot.docs.map(enrichPostWithAuthor)
//       );

//       setPosts(postsData.filter(Boolean));
//       setLastVisible(lastDoc || null);
//     } catch (error) {
//       console.error("Erreur lors de la récupération des posts :", error);
//     }
//   };


//   // Récupérer l'avatar du créateur du post
//   const fetchAvatar = async (userId) => {
//     try {
//       const userRef = doc(db, "users", userId);
//       const docSnap = await getDoc(userRef);
//       if (docSnap.exists()) {
//         const data = docSnap.data();
//         setAvatar(data.avatar);
//       }
//     } catch (error) {
//       console.error("Erreur lors de la sélection de l'utilisateur :", error);
//     }
//   };



//   // Charger plus de posts
//   const loadMorePosts = async () => {
//     try {
//       if (!lastVisible) return;

//       const nextQuery = query(
//         collection(db, "posts"),
//         orderBy("timestamp", "desc"),
//         startAfter(lastVisible),
//         limit(10)
//       );

//       const querySnapshot = await getDocs(nextQuery);
//       const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];

//       if (querySnapshot.empty) {
//         setLastVisible(null);
//         return;
//       }

//       const postsData = await Promise.all(
//         querySnapshot.docs.map(enrichPostWithAuthor)
//       );

//       setPosts((prevPosts) => [
//         ...prevPosts,
//         ...postsData.filter(Boolean),
//       ]);

//       setLastVisible(lastDoc || null);
//     } catch (error) {
//       console.error("Erreur lors du chargement des posts :", error);
//     }
//   };

//   const sortPosts = async (sortBy = "timestamp") => {
//     const postsQuery = query(
//       collection(db, "posts"),
//       orderBy(sortBy, "desc"),
//       limit(10)
//     );
//     const querySnapshot = await getDocs(postsQuery);
//     const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     return posts; // Return the posts array
//   };


//   useEffect(() => {
//     fetchPosts();

//     if (userId) {
//       fetchAvatar(userId);
//     }
//   }, []);

//   // Nombre de cartes Banner3D selon la largeur de l'écran
//   const mobileLimit = 6;
//   const desktopLimit = 10;

//   const [isMobileBanner, setIsMobileBanner] = useState(() =>
//     window.matchMedia("(max-width: 767px)").matches
//   );

//   useEffect(() => {
//     const mediaQuery = window.matchMedia("(max-width: 767px)");

//     const handleBannerBreakpoint = (event) => {
//       setIsMobileBanner(event.matches);
//     };

//     setIsMobileBanner(mediaQuery.matches);

//     mediaQuery.addEventListener("change", handleBannerBreakpoint);

//     return () => {
//       mediaQuery.removeEventListener("change", handleBannerBreakpoint);
//     };
//   }, []);

//   // Filtrer les posts en fonction de la recherche et de la catégorie
//   const filteredPosts = posts.filter((post) => {
//     const matchesSearch = post.title?.toLowerCase()?.includes(searchTerm.toLowerCase());
//     const matchesCategory =
//       selectedCategory === "all" || post.category === selectedCategory;
//     return matchesSearch && matchesCategory;
//   });


//   // Gestion du clic sur une catégorie
//   const handleCategorySelect = (id) => {
//     console.log("Catégorie sélectionnée :", id); // Vérifie l'exécution
//     setSelectedCategory(id);
//     setTimeout(() => {
//       setDropdownOpen(false);
//       setShowSecondaryDropdown(false);
//     }, 100); // Laisse le temps au clic de s'exécuter
//   };


//   // Log le contenu du tableau categories
//   console.log("Liste des catégories :", categories);

//   // Gestion de la creation d'un post
//   const handleCreatePost = () => {
//     if (!isLoggedIn) {
//       setRedirectTo("/Forum?openModal=true");
//       navigate("/connexion");
//       return;
//     }

//     navigate("/create-subject");
//   };


//   // Détecter le paramètre `openModal` dans l'URL
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     if (params.get("openModal") === "true") {
//       setIsModalOpen(true);
//     }
//   }, [location]);


//   // Gestion de la suppression d'un post
//   const handleDelete = async (post) => {
//     const postId = post?.id;

//     if (!postId) return;

//     const isDisplayedAsMovieReview =
//       post?.source === "movie_rating_review" ||
//       post?.type === "movie_rating_discussion";

//     const confirmed = window.confirm(
//       isDisplayedAsMovieReview
//         ? "Supprimer ce sujet d'avis MovieFrenzy ? Le sujet et tous les avis publiés seront retirés, mais les notes seront conservées."
//         : "Supprimer ce sujet ?"
//     );

//     if (!confirmed) return;

//     try {
//       const postRef = doc(db, "posts", postId);
//       const postSnap = await getDoc(postRef);

//       if (!postSnap.exists()) {
//         setPosts((prevPosts) =>
//           prevPosts.filter((currentPost) => currentPost.id !== postId)
//         );
//         return;
//       }

//       const postData = postSnap.data();

//       const isMovieReviewPost =
//         postData?.source === "movie_rating_review" ||
//         postData?.type === "movie_rating_discussion";

//       const repliesRef = collection(db, "posts", postId, "replies");
//       const repliesSnap = await getDocs(repliesRef);

//       /*
//        * Toutes les variations d'activité sont regroupées ici,
//        * puis appliquées une seule fois par utilisateur.
//        */
//       const xpDeltasByUser = {};

//       const addXpDelta = (targetUserId, sourceKey, delta) => {
//         if (!targetUserId || !sourceKey || !delta) return;

//         if (!xpDeltasByUser[targetUserId]) {
//           xpDeltasByUser[targetUserId] = {};
//         }

//         xpDeltasByUser[targetUserId][sourceKey] =
//           (xpDeltasByUser[targetUserId][sourceKey] || 0) + delta;
//       };

//       const rollbackLikes = (likedUserIds, authorId) => {
//         const uniqueLikedUserIds = [
//           ...new Set(Array.isArray(likedUserIds) ? likedUserIds : []),
//         ].filter(
//           (likedUserId) =>
//             likedUserId &&
//             likedUserId !== authorId
//         );

//         uniqueLikedUserIds.forEach((likedUserId) => {
//           addXpDelta(likedUserId, "likesGiven", -1);
//         });

//         if (authorId && uniqueLikedUserIds.length > 0) {
//           addXpDelta(
//             authorId,
//             "likesReceived",
//             -uniqueLikedUserIds.length
//           );
//         }
//       };

//       const postAuthorId = postData?.authorId;

//       /*
//        * Un sujet ordinaire donne de l'activité "posts".
//        *
//        * Un sujet d'avis MovieFrenzy ne doit pas retirer ici
//        * movieReviews à l'auteur du sujet, car chaque avis est
//        * enregistré dans la sous-collection replies et sera
//        * traité séparément plus bas.
//        */
//       if (postAuthorId && !isMovieReviewPost) {
//         addXpDelta(postAuthorId, "posts", -1);
//       }

//       rollbackLikes(postData?.likes, postAuthorId);

//       /*
//        * Liste des avis MovieFrenzy à nettoyer dans :
//        *
//        * users/{userId}/movieReviews/{movieRatingKey}
//        *
//        * et :
//        *
//        * movieRatings/{movieRatingKey}/userRatings/{userId}
//        */
//       const movieReviewCleanupTargets = [];

//       repliesSnap.docs.forEach((replyDoc) => {
//         const replyData = replyDoc.data();
//         const replyAuthorId = replyData?.authorId;

//         const isMovieReviewReply =
//           replyData?.source === "movie_rating_review";

//         if (replyAuthorId) {
//           addXpDelta(
//             replyAuthorId,
//             isMovieReviewReply ? "movieReviews" : "replies",
//             -1
//           );
//         }

//         rollbackLikes(replyData?.likes, replyAuthorId);

//         if (isMovieReviewReply && replyAuthorId) {
//           const movieRatingKey = String(
//             replyData?.movieRatingKey ||
//             replyData?.tmdbId ||
//             postData?.movieRatingKey ||
//             postData?.tmdbId ||
//             ""
//           );

//           if (movieRatingKey) {
//             movieReviewCleanupTargets.push({
//               authorId: replyAuthorId,
//               movieRatingKey,
//             });
//           }
//         }
//       });

//       /*
//        * Évite de traiter deux fois le même avis si les données
//        * contiennent accidentellement un doublon.
//        */
//       const uniqueMovieReviewTargets = [
//         ...new Map(
//           movieReviewCleanupTargets.map((target) => [
//             `${target.authorId}-${target.movieRatingKey}`,
//             target,
//           ])
//         ).values(),
//       ];

//       /*
//        * On vérifie l'existence des documents userRatings avant
//        * de les modifier, sinon tout le batch pourrait échouer.
//        */
//       const movieReviewDocuments = await Promise.all(
//         uniqueMovieReviewTargets.map(async ({
//           authorId,
//           movieRatingKey,
//         }) => {
//           const userRatingRef = doc(
//             db,
//             "movieRatings",
//             movieRatingKey,
//             "userRatings",
//             authorId
//           );

//           const profileReviewRef = doc(
//             db,
//             "users",
//             authorId,
//             "movieReviews",
//             movieRatingKey
//           );

//           const userRatingSnap = await getDoc(userRatingRef);

//           return {
//             userRatingRef,
//             userRatingExists: userRatingSnap.exists(),
//             profileReviewRef,
//           };
//         })
//       );

//       const batch = writeBatch(db);

//       /*
//        * Suppression de toutes les réponses du sujet.
//        */
//       repliesSnap.docs.forEach((replyDoc) => {
//         batch.delete(replyDoc.ref);
//       });

//       /*
//        * Suppression des vignettes de profil et nettoyage des
//        * métadonnées d'avis, sans supprimer la note du film.
//        */
//       movieReviewDocuments.forEach(({
//         userRatingRef,
//         userRatingExists,
//         profileReviewRef,
//       }) => {
//         batch.delete(profileReviewRef);

//         if (userRatingExists) {
//           batch.update(userRatingRef, {
//             hasReview: false,
//             forumPostId: deleteField(),
//             forumReplyId: deleteField(),
//             reviewText: deleteField(),
//             reviewUpdatedAt: deleteField(),
//           });
//         }
//       });

//       /*
//        * Application des diminutions d'activité.
//        */
//       Object.entries(xpDeltasByUser).forEach(
//         ([targetUserId, sourceDeltas]) => {
//           const userRef = doc(db, "users", targetUserId);

//           const xpUpdates = Object.entries(sourceDeltas).reduce(
//             (updates, [sourceKey, delta]) => ({
//               ...updates,
//               [`xp.sources.${sourceKey}`]: increment(delta),
//             }),
//             {}
//           );

//           batch.update(userRef, {
//             ...xpUpdates,
//             "xp.updatedAt": serverTimestamp(),
//           });
//         }
//       );

//       /*
//        * Suppression définitive du sujet.
//        */
//       batch.delete(postRef);

//       await batch.commit();

//       setPosts((prevPosts) =>
//         prevPosts.filter(
//           (currentPost) => currentPost.id !== postId
//         )
//       );

//       console.log(
//         `[Forum] Sujet ${postId} et données associées supprimés avec succès.`
//       );
//     } catch (error) {
//       console.error(
//         "Erreur lors de la suppression du sujet :",
//         error
//       );

//       alert(
//         "Une erreur est survenue lors de la suppression du sujet. Veuillez réessayer."
//       );
//     }
//   };



//   const setUserOnline = async (uid) => {
//     const userRef = doc(db, "users", uid);
//     await updateDoc(userRef, { isOnline: true });
//   };

//   const setUserOffline = async (uid) => {
//     const userRef = doc(db, "users", uid);
//     await updateDoc(userRef, { isOnline: false });
//   };

//   useEffect(() => {
//     if (uid) {
//       setUserOnline(uid); // Définit l'utilisateur comme en ligne
//     }

//     // Nettoyage à la suppression du composant ou au changement de uid
//     return () => {
//       if (uid) {
//         setUserOffline(uid); // Définit l'utilisateur comme hors ligne avant de quitter
//       }
//     };
//   }, [uid]);

//   const fetchOnlineUsers = () => {
//     const q = query(collection(db, "users"), where("isOnline", "==", true)); // Filtrer les utilisateurs en ligne
//     const unsubscribe = onSnapshot(q, (snapshot) => {
//       const onlineUsers = snapshot.docs.map((doc) => ({
//         uid: doc.id,
//         ...doc.data(),
//       }));
//       console.log("Utilisateurs en ligne :", onlineUsers);
//       setOnlineUsersCheck(onlineUsers); // Met à jour l'état avec les utilisateurs en ligne
//     });

//     return unsubscribe; // Retourne l'écouteur pour le nettoyage
//   };

//   useEffect(() => {
//     const unsubscribe = fetchOnlineUsers(); // Récupère l'écouteur
//     return () => unsubscribe(); // Nettoyage à la suppression du composant
//   }, []);

//   const limitedUsers = onlineUsers.slice(0, 10); // Affiche les 10 premiers utilisateurs en ligne

//   // Pour modifier un post
//   const handleEdit = (post) => {
//     navigate(`/edit-subject/${post.id}`);
//   };



//   // Pour annuler la modification
//   const handleCancelEdit = () => {
//     setEditingPost(null);
//     setEditTitle("");
//     setEditContent("");
//   };

//   const handleSaveEdit = async () => {
//     if (!editTitle || !editContent) {
//       alert("Tous les champs doivent être remplis !");
//       return;
//     }

//     try {
//       const postRef = doc(db, "posts", editingPost); // Référence du document en cours d'édition
//       await updateDoc(postRef, {
//         title: editTitle,
//         content: editContent,
//         timestamp: serverTimestamp(), // Met à jour le timestamp
//       });
//       fetchPosts(); // Actualise la liste des posts
//       setEditingPost(null); // Ferme le mode édition
//     } catch (error) {
//       console.error("Erreur lors de la modification :", error);
//     }
//   };

//   // Gestion du clic sur un sujet pour redirection
//   const handleSubjectClick = (postId) => {
//     navigate(`/subject/${postId}`); // Redirige vers la page du sujet
//   };

//   // // Gestion du comptage des réponses
//   const fetchReplyCount = async (postId) => {
//     try {
//       // Compter les réponses dans la sous-collection "replies"
//       const repliesQuery = query(collection(db, "posts", postId, "replies"));
//       const repliesSnapshot = await getDocs(repliesQuery);
//       const repliesCount = repliesSnapshot.size;

//       // Inclure le post lui-même comme un "message"
//       return repliesCount + 1; // Ajoute le sujet principal
//     } catch (err) {
//       console.error("Erreur lors du comptage des réponses :", err);
//       return 1; // Par défaut, inclure au moins le sujet lui même
//     }
//   };

//   // ogique d'affichage pour chercher dans plusieurs tableaux
//   const selectedCategoryObj =
//     categories.find(cat => cat.id === selectedCategory) ||
//     secondaryCategories.find(cat => cat.id === selectedCategory);

//   // Fonction pour trier les sujets
//   const getTopicActivityTime = (topic) => {
//     return topic.lastActivityAt?.seconds || topic.timestamp?.seconds || 0;
//   };

//   const getLikeCount = (likes) => {
//     return Array.isArray(likes) ? likes.length : Number(likes || 0);
//   };

//   const sortTopics = (topics) => {
//     return [...topics].sort((a, b) => {
//       const bActivityTime = getTopicActivityTime(b);
//       const aActivityTime = getTopicActivityTime(a);

//       if (bActivityTime !== aActivityTime) {
//         return bActivityTime - aActivityTime;
//       }

//       const bReplies = Number(b.replies || 0);
//       const aReplies = Number(a.replies || 0);

//       if (bReplies !== aReplies) {
//         return bReplies - aReplies;
//       }

//       return getLikeCount(b.likes) - getLikeCount(a.likes);
//     });
//   };

//   const visiblePosts = sortTopics(filteredPosts);

//   const popularTopics = sortTopics(posts).slice(0, desktopLimit);

//   const bannerTopics = popularTopics.slice(
//     0,
//     isMobileBanner ? mobileLimit : desktopLimit
//   );


//   return (
//     <>
//       <div
//         className="forum-page"
//         style={{
//           backgroundImage: `url(${darkwaterImageUrl})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           backgroundAttachment: "fixed",
//           backgroundBlendMode: "overlay",
//           backgroundColor: "#200211",
//           opacity: "0.9",
//           overflowX: "hidden",
//           overflowY: "auto",
//           minHeight: "100vh",
//         }}
//       >
//         <NavigationBar />
//         <div className="forum-container">
//           <div
//             className="forum-banner3d-wrapper"
//             style={{
//               width: "100%",
//               height: "100%",
//               zIndex: "100001",
//               marginTop: "1rem"
//             }}
//           >
//             <h2 className="forum-hot-topics-mobile">
//               {t('banner3d.hotTopics')}
//             </h2>

//             <Banner3D topics={bannerTopics} />
//           </div>

//           <div className="forum-controls" style={{ marginTop: '3rem' }}>
//             <input
//               type="text"
//               placeholder={t('forum.searchPlaceholder')}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             <div className="custom-dropdown">
//               <div className="selected-option" onClick={() => setDropdownOpen(!dropdownOpen)}>
//                 {selectedCategoryObj ? t(`forum.forumCategories.${selectedCategoryObj.id}`) : t('forum.categoryPlaceholder')}
//                 <span className={`chevron ${dropdownOpen ? "open" : ""}`}>
//                   {dropdownOpen ? "▲" : "▼"}
//                 </span>
//               </div>
//               {dropdownOpen && (
//                 <div className="dropdown-compartments">
//                   <ul className="popular-categories">
//                     {popularCategories.map((cat) => (
//                       <li
//                         key={cat.id}
//                         onClick={(e) => {
//                           e.stopPropagation(); // Empêche l'interception
//                           console.log("Catégorie secondaire cliquée :", cat.id); // Debug
//                           console.log("dropdownOpen :", dropdownOpen, "showSecondaryDropdown :", showSecondaryDropdown);
//                           console.log("[POPULAIRE] Catégorie cliquée :", cat.id);
//                           handleCategorySelect(cat.id);
//                         }}
//                       >
//                         {t(`forum.forumCategories.${cat.id}`)}
//                       </li>
//                     ))}
//                     <li
//                       className="more-categories"
//                       onClick={(e) => {
//                         e.stopPropagation(); // Empêche l'interception
//                         handleMoreCategoriesClick();
//                       }}
//                     >
//                       {t('forum.moreCategories')}
//                     </li>
//                     {showSecondaryDropdown && (
//                       <ul className={`secondary-categories ${dropdownOpen ? "active" : ""}`}>
//                         {/* <ul className="secondary-categories">   */}
//                         {secondaryCategories.map((cat) => (
//                           <li
//                             key={cat.id}
//                             tabIndex={0}
//                             role="menuitem"
//                             onClick={(e) => {
//                               e.stopPropagation(); // Empêche l'interception
//                               console.log("Catégorie secondaire cliquée :", cat.id); // Debug
//                               console.log("[SECONDAIRE] Catégorie cliquée :", cat.id);
//                               handleCategorySelect(cat.id);
//                             }}
//                           >
//                             {t(`forum.forumCategories.${cat.id}`)}
//                           </li>
//                         ))}
//                       </ul>
//                     )}
//                   </ul>
//                   {showMoreCategories && (
//                     <ul className="other-categories">
//                       {otherCategories.map((cat) => (
//                         <li key={cat.id} onClick={() => handleCategorySelect(cat.id)}>
//                           {t(`forum.forumCategories.${cat.id}`)}
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               )}
//             </div>
//             <button
//               className="buttonForum01"
//               onClick={() => setShowRules(!showRules)}
//             >
//               {t('forum.showRules')}
//             </button>
//             <button className="buttonForum01" onClick={handleCreatePost}>
//               {t('forum.createTopic')}
//             </button>
//           </div>
//           {showRules && (
//             <div className="forum-rules">
//               <h2>{t('forum.rulesTitle')}</h2>
//               <ul>
//                 {t('forum.rules', { returnObjects: true }).map((rule, index) => (
//                   <li key={index}>{rule}</li>
//                 ))}
//               </ul>
//             </div>
//           )}
//           {visiblePosts && visiblePosts.length > 0 ? (
//             visiblePosts.map((post) => {
//               const postActivityScore = debugTestMode
//                 ? testMessageCount
//                 : (post.activityScore ?? post.messageCount ?? 0);

//               console.log("Niveau envoyé à UserXpAvatar :", postActivityScore);

//               return (
//                 <div
//                   key={post.id}
//                   className="forum-post"
//                   style={{
//                     marginBottom: "1.25rem",
//                     padding: "1.5rem",
//                     backgroundColor: "rgba(255, 255, 255, 0.1)",
//                     borderRadius: "0.5rem",
//                     boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.5)",
//                     cursor: "pointer", // Ajout pour indiquer que c'est cliquable
//                     transition: "background-color 0.3s",
//                     border: "2px solid #00FFFF",
//                   }}
//                   onClick={() => navigate(`/subject/${post.id}`)}
//                 >
//                   <h3 className="Title_topic" style={{ color: "#00FFFF" }}>
//                     {post.title}
//                   </h3>
//                   <p dangerouslySetInnerHTML={{ __html: post.content }}></p>
//                   <div
//                     className="post-details"
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       gap: "0.8rem",
//                       fontSize: "0.9rem",
//                       borderColor: "#FF33CC",
//                       borderTop: "2px solid #FF33CC",
//                       padding: "1.5rem",
//                       borderStyle: "dotted",
//                       filter: "brightness(0.9) drop-shadow(0 0 0.5rem #FF33CC)",
//                     }}
//                   >
//                     <div
//                       className="avatar-containerForumHome"
//                       style={{
//                         color: "#00FFFF",
//                         fontSize: "0.8rem",
//                         backgroundColor: "#200211",
//                         padding: "0.5rem",
//                         borderRadius: "0.25rem",
//                       }}
//                     >
//                       {t('forum.by')}{" "}
//                       <span style={{ fontWeight: "bold", color: "white" }}>
//                         {post.authorName || post.author || t('forum.authorUnknown')}
//                       </span>
//                       <div
//                         className="avatar-containerForumHome"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           marginTop: "0.5rem",
//                           gap: "0.5rem",
//                           flexDirection: "row",
//                         }}
//                       >
//                         <UserXpAvatar
//                           avatarUrl={post.avatar || defaultAvatarUrl}
//                           activityScore={postActivityScore}
//                           fallbackActivityScore={post.messageCount}
//                           userId={post.authorId}
//                           titleLabel={t("forum.levelTitle")}
//                           activityLabel={t("forum.activityScore")}
//                           className="user-xp-avatar--forum-home"
//                         />
//                       </div>
//                     </div>
//                     <span style={{ color: "#00FFFF" }}>
//                       {t('forum.category')}{" "}
//                       <span style={{ fontWeight: "bold", color: "white" }}>
//                         {t(`forum.forumCategories.${post.category}`)}
//                       </span>
//                     </span>
//                     <span
//                       style={{
//                         color: "#00FFFF",
//                         fontSize: "0.8rem",
//                         cursor: "pointer",
//                         padding: "0.2rem",
//                         borderRadius: "0.25rem",
//                       }}
//                     >
//                       {post.timestamp?.seconds
//                         ? new Date(post.timestamp.seconds * 1000).toLocaleString()
//                         : t('forum.dateUnknown')}
//                     </span>
//                   </div>
//                   {post.authorId === userId && (
//                     <div className="button-container">
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation(); // Arrête la propagation vers le parent
//                           handleEdit(post);
//                         }}
//                         className="editButton"
//                       >
//                         {t('forum.edit')}
//                       </button>
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleDelete(post);
//                         }}
//                         className="deleteButton"
//                       >
//                         {t('forum.delete')}
//                       </button>
//                     </div>
//                   )}
//                   {editingPost === post.id && (
//                     <div>
//                       <h3>{t('forum.editTopic.pageTitle')}</h3>
//                       <label>
//                         {t('forum.editTopic.titleLabel')}
//                         <input
//                           type="text"
//                           value={editTitle}
//                           onChange={(e) => setEditTitle(e.target.value)}
//                         />
//                       </label>
//                       <label>
//                         {t('forum.editTopic.contentLabel')}
//                         <textarea
//                           value={editContent}
//                           onChange={(e) => setEditContent(e.target.value)}
//                         />
//                       </label>
//                       <button onClick={handleSaveEdit} className="editButton">
//                         {t('forum.editTopic.save')}
//                       </button>
//                       <button
//                         onClick={() => handleCancelEdit()}
//                         className="cancelButton"
//                       >
//                         {t('forum.editTopic.cancel')}
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               );
//             })
//           ) : (
//             <p>{t('forum.noTopics')}</p>
//           )}
//           <button onClick={loadMorePosts} disabled={!lastVisible} className="buttonForumChargerMore" style={{ filter: "drop-shadow(0px 0px 10px rgba(255, 51, 204))" }}>
//             <span className="chargerSpanButtonForum" data-loading-text={t('forum.loadingText')}>
//               {t('forum.loadMore')}
//             </span>
//           </button>
//           <div className="forum-online-users"
//             style={{
//               color: "#00FFFF",
//               fontSize: "0.8rem",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               borderColor: "#FF33CC",
//               borderTop: "2px solid #FF33CC",
//               padding: "1.5rem",
//               borderStyle: "dotted",
//               filter: "brightness(0.9) drop-shadow(0 0 0.5rem #FF33CC)",
//               backgroundImage: `url(${frenzyMimiWallImageUrl})`,
//               backgroundSize: "cover",
//               backgroundPosition: "center",
//               backgroundRepeat: "no-repeat",
//               backgroundAttachment: "fixed",
//               backgroundBlendMode: "overlay",
//               backgroundColor: "rgba(32, 0, 17, 0.75)",
//             }}
//           >
//             <TsparticlesForForum />
//             <h2>{t('forum.onlineUsers')}</h2>
//             {onlineUsersCheck.length === 0 ? (
//               <p>{t('forum.noOnlineUsers')}</p>
//             ) : (
//               <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "0.75rem", margin: "0.5rem auto 0.5rem auto" }}>
//                 {onlineUsersCheck.map((user) => (
//                   <li key={user.uid} style={{ marginBottom: "0.5rem", color: "#FFFFFF", fontSize: "0.8rem", marginRight: "calc(50% - 48.25vw)", marginLeft: "calc(50% - 50vw)", textShadow: "0 0 0.5rem #000" }}>{user.username || t('forum.anonymousUser')}</li>
//                 ))}
//               </ul>
//             )}
//           </div>
//         </div>
//       </div>
//       <div>
//         <BackToTopButton />
//       </div>
//       <div className="actor-details-footer"
//         style={{ maxWidth: '100%', maxHeight: '100%' }}
//       >
//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Forum;
